<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><g
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.5"
    clip-path="url(#a)"
  ><path d="M12.696 9.967a5.563 5.563 0 1 0-6.954 5.387v5.689a1.39 1.39 0 0 0 2.782 0v-5.689a5.563 5.563 0 0 0 4.172-5.387Z" /><path d="M13.45 15.476a5.536 5.536 0 0 0 2.056-.716l4.55 4.548a1.39 1.39 0 0 0 1.966-1.966l-4.552-4.548a5.562 5.562 0 0 0-7.564-7.65M5.742 9.272a1.39 1.39 0 1 0 2.781 0 1.39 1.39 0 0 0-2.78 0Z" /><path d="M7.133 7.881V3.656a2.086 2.086 0 1 1 4.172 0v.917" /></g><defs><clipPath id="a"><path
    fill="none"
    d="M0 0h24v24H0z"
  /></clipPath></defs></svg>
</template>
